module.exports = __webpack_public_path__ + "img/tb(13).b0c0fa20.png";